module.exports = __webpack_public_path__ + "img/back.2980b82e.png";